<template lang="pug">
	app-header-dropdown(right no-caret)
		template(slot='header')
			div.d-flex.align-items-center
				div(is="Avatar" :_image="account.data.avatar||defaultAvatar")
				div.ml-1.mr-3.d-none.d-lg-block
					div {{ account.data.first_name || "unknown" }}
					div {{ account.data.last_name || "unknown" }}


		template(slot='dropdown')

			// b-dropdown-header.text-center(tag='div')
				strong Account
			// b-dropdown-item
				i.fa.fa-bell-o
				| Updates
				b-badge(variant='info') {{ itemsCount }}
			// b-dropdown-item
				i.fa.fa-envelope-o
				| Messages
				b-badge(variant='success') {{ itemsCount }}
			// b-dropdown-item
				i.fa.fa-tasks
				| Tasks
				b-badge(variant='danger') {{ itemsCount }}
			// b-dropdown-item
				i.fa.fa-comments
				| Comments
				b-badge(variant='warning') {{ itemsCount }}

			// b-dropdown-header.text-center(tag='div')
				strong Settings
			// b-dropdown-item(@click="$router.push('/profile')")
				i.fa.fa-user
				| Профайл
			b-dropdown-item(@click="$router.push('/settings')")
				i.fa.fa-wrench
				| Настройки
			// b-dropdown-item
				i.fa.fa-usd
				| Payments
				b-badge(variant='secondary') {{ itemsCount }}
			// b-dropdown-item
				i.fa.fa-file
				| Projects
				b-badge(variant='primary') {{ itemsCount }}
			<!--b-dropdown-item-->
			<!--i.fa.fa-shield-->
			<!--| Lock Account-->
			b-dropdown-item(@click='signOut')
				i.fa.fa-lock
				| Выйти
</template>

<script>
	import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue'

	import { mapState, mapGetters,mapActions } from 'vuex'
	import Avatar from '../views/components/avatar';

	export default {
		name: 'DefaultHeaderDropdownAccnt',
		components: {
			AppHeaderDropdown,
			Avatar,
		},
		data: () => ({
			defaultAvatar: '/img/placeholders/avatar.png',
			transition: 'slide-right',
			itemsCount: 42,
		}),
		computed: {
			...mapState(['account','connectedList','socket']),
			...mapGetters(['fullName']),
		},
		methods: {
			...mapActions(['setConnectedList']),
			signOut() {
				this.$store.dispatch('logOut').then(() => {});
			},
		},
		beforeMount(){
			if ( this.socket ){
				this.socket.emit('user_connected');
				this.socket.on('send', data => this.$store.dispatch('setConnectedList',data.connectedList) );
				this.socket.on('user_disconnected', data => this.$store.dispatch('setConnectedList',data.connectedList) )
			}
		}
	}
</script>
